import React from "react"

import Loading from "components/Loading"
import Modal from "components/Modal"
import { useAppContext } from "contexts/AppProvider"
import Layout from "layout"
import Dashboard from "pages/Dashboard"
import Machine from "pages/Machine"
import RoomDetail from "pages/RoomDetail"
import { BrowserRouter, Routes, Route } from "react-router-dom"
import { ToastContainer } from "react-toastify"

import "./index.css"
import "./variables.css"
import "react-toastify/dist/ReactToastify.css"

const App = () => {
    const { isLoading, isModalTutorialDisplayed, setIsModalTutorialDisplayed } = useAppContext()

    return (
        <BrowserRouter>
            { isLoading && <Loading /> }

            <Modal
                close={ () => setIsModalTutorialDisplayed(false) }
                isOpen={ isModalTutorialDisplayed }
            >
                <div className="tablet:w-[400px] w-screen max-h-[600px] overflow-auto text-secondary px-4 py-8">
                    <p className=" text-xl mb-4 font-semibold leading-4 text-center">
                        Hướng dẫn vào phòng
                    </p>

                    <p className="font-semibold mt-1">
                        Người chơi thứ nhất tạo phòng . Người chơi thứ 2 sẽ có 2 cách để vào phòng
                    </p>

                    <p className="mt-1">
                        Cách 1 : Người chơi thứ nhất tạo phòng xong sẽ đưa người thứ 2{ " " }

                        <span className="font-semibold">ID phòng</span> . Người thứ 2 sẽ vào ấn vào{ " " }

                        <span className="font-semibold">nút tìm phòng</span> ở trang chủ và paste{ " " }

                        <span className="font-semibold">ID phòng</span> và vào
                    </p>

                    <p className="mt-1">
                        Cách 2 : Người chơi thứ nhất tạo phòng xong sẽ đưa người thứ 2{ " " }

                        <span className="font-semibold">link phòng</span> . Người thứ 2 sẽ sử dụng{ " " }

                        <span className="font-semibold">link phòng</span> đấy để truy cập và vào
                    </p>

                    <p className=" text-xl mb-4  mt-8 tablet:mt-10 font-semibold leading-4 text-center">
                        Luật chơi daudit
                    </p>

                    <p className="font-semibold mb-1">
                        Dựa vào series trên tờ tiền ( 7 chữ số ) và bóng đã giao để xác định điểm
                        của người chơi
                    </p>

                    <p>
                        Sẽ có 2 tờ tiền trong tay trái và tay phải . Mỗi người sẽ lấy 1 tờ tiền.Bóng
                        được giao sẽ lấy theo số thứ tự từng số trong series tiền ( 7 chữ số ) cộng
                        lại để tính điểm , nếu bóng giao gồm có lớn ăn thì người chơi nào có điểm
                        lớn hơn người đó thắng , và ngược lại với bé ăn.
                    </p>

                    <p>
                        <span className="italic">VD</span> : Bóng giao là 1 2 3 bé ăn , thì sẽ lấy
                        số thứ nhất , thứ 2 , thứ 3 của số series tờ tiền cộng lại , người chơi nào
                        có điểm bé hơn người đó thắng . Người chơi 1 có series là 1234567 thì điểm
                        sẽ là 6 , người chơi 2 có series là 6985244 thì điểm sẽ là 3 (tổng là 23

                        nhưng làm tròn về 3) ={ `>` } Người chơi 2 thắng.
                    </p>

                    <p className="font-semibold mt-2 mb-1">Các bước của 1 game</p>

                    <p className="mt-1 text-center">
                        1.Giao bóng -{ `>` } 2.Nặn bóng -{ `>` } 3.So điểm
                    </p>

                    <p className="mt-2">
                        Bước 1 : Người chơi có quyền giao bóng sẽ chọn thứ tự con số trên series
                        tiền (VD: 1 2 3 , 2 đầu 2 đít tương đương 1 2 6 7 ) và giá trị tờ tiền (bé
                        ăn hoặc lớn ăn) . Sau đó , người này sẽ chọn tiền ở tay trái hoặc tay phải ,
                        người còn lại sẽ lấy tờ còn lại
                    </p>

                    <p className="mt-1">
                        Bước 2 : Cả 2 người chơi sẽ được xem series tờ tiền và tính điểm của mình.
                    </p>

                    <p className="mt-1">
                        Bước 3 : Cả 2 người chơi sẽ biết series tờ tiền của nhau , tính lại điểm để
                        biết ai là người thắng cuộc.
                    </p>

                    <p className="font-semibold mt-2 mb-1">Quy ước</p>

                    <p className="mt-1">
                        1 . Tổng 10 sẽ là tịt nên dù trường hợp bé ăn hay lớn ăn thì đều là bé nhất
                        (VD: 2 đầu 2 đít của bóng 9100082 sẽ là 20 làm tròn 10 ={ `>` } tịt )
                    </p>

                    <p className="mt-1">
                        2 . Trường hợp điểm 2 người bằng nhau thì sẽ hòa (VD: cả 2 người chơi đều
                        tịt ={ `>` } hòa)
                    </p>

                    <p className="mt-1">
                        3 . Người giao bóng sẽ là người được chọn tay để lấy tiền (tay trái hoặc
                        phải)
                    </p>
                </div>
            </Modal>

            <ToastContainer />

            <Layout>
                <Routes>
                    <Route element={ <RoomDetail /> } path="/room/:id" />

                    <Route element={ <Machine /> } path="/machine" />

                    <Route element={ <Dashboard /> } path="/" />
                </Routes>
            </Layout>
        </BrowserRouter>
    )
}

export default App
